/**
 * usage: `if (e.code === ComponentsInputConstantS.KEY_CODE.ARROW_DOWN)`
 */
export const KEY_CODE = Object.freeze({
  ENTER: 'Enter',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ESC: 'Escape',
});
